<template>
  <div>
    <transition name="fade" appear>
      <div class="modal-overlay" v-if="showModal" @click="hideModal"></div>
    </transition>
    <transition name="pop" appear>
      <div class="modal" v-if="showModal">
        <!--:player-vars="{ autoplay: 1 }"-->
        <youtube
          :video-id="videoLink"
          @ready="ready"
          @playing="playing"
          class="video-overlay"
          :player-width="videoSize.width"
          :player-height="videoSize.height"
        ></youtube>
        <div class="close">
          <span @click="hideModal"></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { enablePageScroll } from "scroll-lock";

export default {
  name: "show-modal",
  data() {
    return {};
  },
  computed: {
    videoLink() {
      var link = this.$store.getters.showModal.videoLink;
      return link;
    },
    videoSize() {
      var size = {
        width: "1280px",
        height: "720px",
      };
      if (document.documentElement.clientWidth < 768) {
        size.width = "330px";
        size.height = "185px";
      } else if (document.documentElement.clientWidth < 599) {
        size.width = "560px";
        size.height = "315px";
      } else if (document.documentElement.clientWidth < 1199) {
        size.width = "760px";
        size.height = "420px";
      } else if (document.documentElement.clientWidth < 1399) {
        size.width = "960px";
        size.height = "540px";
      }
      return size;
    },
    showModal() {
      var showModal = this.$store.getters.showModal;
      return showModal.show;
    },
  },
  methods: {
    hideModal() {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);

      var payloader = {
        show: false,
        videoLink: "",
      };
      this.$store.commit("showModal", payloader);
    },
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      // The player is playing a video.
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
  },
};
</script>
<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 10px 10px 50px rgba(0, 0, 0, 0.3);
  background: #000;
  z-index: 999;
  & > div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .close {
    position: absolute;
    top: -2rem;
    right: -2rem;
    width: 4rem;
    height: 4rem;
    background: $orange;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    span {
      width: 2rem;
      height: 2rem;
      background: url(../../assets/img/close.svg) center center/contain
        no-repeat;
    }
  }
}
.modal-overlay {
  position: fixed !important;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: #fff;
  opacity: 0.9;
  cursor: pointer;
}

/* ---------------------------------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-leave-to {
  transition-delay: 0.3s;
}

.pop-enter-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.3s linear;
}
.pop-leave-active {
  transition: transform 0.3s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.2s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.5) translateY(-50%, -50%);
}
</style>